export enum FormulaTagType {
	Field = 1,
	Operator = 2,
	GroupOperator = 3,
	Custom = 4
}